import { MortgageLenderSubBranch } from "./MortgageLenderSubBranch";
import { MortgageLenderItem } from "./MortgageLenderTypes";

export function buildMortgageLenderHeaders(
    listColumns: string[],
    handleColumnClick: (columnAttr: string) => void,
    provinceShort: string,
    getSortIcon: (columnAttr: string) => JSX.Element,
) {
    const handleClick = (columnAttr: string) => {
        handleColumnClick(columnAttr);
    }

    return (
        <tr>
            <th></th>
            <th onClick={() => handleClick("Name")} style={{cursor: 'pointer'}}>
                {getSortIcon("Name")}
                Name
            </th>
            <th></th>
        </tr>
    )
}

export function buildMortgageLenderLink(
    typeLender: "Misc" | "Mortgage_lender",
    searchText?: string // used for miscellaneous list
) {
    return (LenderEntry: MortgageLenderItem) => {
        return (
            <LenderLink
                LenderEntry={LenderEntry}
                typeLender={typeLender}
                key={`${LenderEntry['Name']}`}
                showSubBranch={searchText > "" || false}
            />
        )
    }
}

export type LenderLinkType = {
    LenderEntry: MortgageLenderItem,
    typeLender: "Misc" | "Mortgage_lender",
    setField?: (string) => void,
    closeFunc?: (boolean) => void,
    fieldType?: string,
    showSubBranch?: boolean,
}

const LenderLink = (props: LenderLinkType) => {
    if (props.typeLender !== 'Misc') {
        return (
            (!(props.LenderEntry['LDDLenderID'] === 1000001 && props.LenderEntry['LenderID'] === 1000000001) &&
                <MortgageLenderSubBranch
                    LenderEntry={props.LenderEntry}
                    typeOfLender={'Mortgage_lender'} // used to be 'branch'
                />)
        )
    } else {
        return (
            ((props.LenderEntry['LDDLenderID'] === 1000001 && props.LenderEntry['LenderID'] === 1000000001) &&
                <MortgageLenderSubBranch
                    LenderEntry={props.LenderEntry}
                    typeOfLender={'Misc'}
                    showSubBranch={props.showSubBranch || false}
                />)
        )
    }

}